import request from '@/utils/request'

/**
 * 查询账户明细列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAccountDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/account/queryAccountDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询账户列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAccount(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/account.listAccount',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}